import { isZoomexApp } from '@region-lib/helper';
import React, { useContext, useState } from 'react';
import './index.less';

interface ModalOptions {
  regEmail?: string;
  showReg?: boolean;
  regPhone?: string;
}

interface CallbackOptions {
  registerCallBack?: () => void;
  loginCallBack?: () => void;
}

const QuickLoginContext = React.createContext({
  openModel: () => {
    return;
  },
  closeModel: () => {
    return;
  },
  loginSuccess: false,
  registerSuccess: false,
  loginClose: false,
  registerClose: false,
});
QuickLoginContext.displayName = 'QuickLoginContext';

export const QuickLoginProvider = ({
  children,
  disableSwitch = false,
  refCodeDisabled = false,
}) => {
  // const modalRef = useRef(null);
  // const iframeRef = useRef(null);
  // const [showRegState, setShowRegState] = useState(false);

  const closeModel = () => {};
  let regionQuickLoginInstanceParams = null;

  const openAppLogin = () => {
    try {
      import('@region/hecate').then((Module) => {
        const HC = new Module.Hecate();

        const paramsObj = {
          uniqueId: 'Router.push.529326ae-3fb7-41ad-82d3-7789d49a213b',
          methodName: 'push',
          params: {
            preAction: true,
            path: 'loginpage',
            title: 'fb',
            fromWeb: '1',
          },
        };

        HC.ready(({ VERSION }) => {
          console.log('Hecate is ready - 1: ', VERSION);
          HC.module('Router')
            .method('push')
            .invoke(paramsObj.params, (json) => {
              console.log('paramsObj', json);
              window.location.reload();
            });
        }).then(({ VERSION }) => {
          console.log('Hecate is ready - 2: ', VERSION);
        });
      });
    } catch (error) {
      console.log(error);
    }
    // Hecate.module('Router')
    //   .method('push')
    //   .invoke(
    //     '{"uniqueId":"Router.push.529326ae-3fb7-41ad-82d3-7789d49a213b","methodName":"push","params":{"preAction":true,"path":"loginpage","fromWeb":"1"}'
    //   )
    //   .then((json) => console.log(json));
  };

  const openModel = (
    options?: ModalOptions,
    callBackOptions?: CallbackOptions
  ) => {
    if (isZoomexApp()) {
      // 调用 APP 原生登录
      openAppLogin();
      return;
    }

    import('src/components/quick-login/useQuickLogin').then(async (m) => {
      const { useRegionQuickLogin } = m;

      const { showReg, regEmail } = options || {};
      const { registerCallBack, loginCallBack } = callBackOptions || {};
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { componentRegionQuickLogin } = await useRegionQuickLogin({
        showReg,
        regEmail,
        disableSwitch,
        refCodeDisabled,
      });

      componentRegionQuickLogin.then((res) => {
        regionQuickLoginInstanceParams = res;
        const { emitOpenModal, onLoginSuccess, onRegisterSuccess } =
          regionQuickLoginInstanceParams;
        emitOpenModal();
        onLoginSuccess(() => {
          loginCallBack && loginCallBack();
          setLoginSuccess(true);
        });
        onRegisterSuccess(() => {
          registerCallBack && registerCallBack();
          setRegisterSuccess(true);
        });
      });
    });

    // iframe.src = iframeSrc;

    // const dom = modalRef.current;
    // // Set delay to show since change url would cause flash
    // setTimeout(
    //   () => {
    //     dom.style.visibility = 'visible';
    //   },
    //   options ? 400 : 0
    // );

    // // Reset status
    // setLoginClose(false);
    // setRegisterClose(false);
  };
  // const initIframe = (window, iframe) => {
  //   const { search } = window.location;
  //   let queryParams = search || '';
  //   if (!search.includes('medium') && defaultQuery?.medium) {
  //     queryParams = queryParams.concat(
  //       `${queryParams.includes('?') ? '&' : '?'}medium=${defaultQuery?.medium}`
  //     );
  //   }
  //   if (!search.includes('source') && defaultQuery?.source) {
  //     queryParams = queryParams.concat(
  //       `${queryParams.includes('?') ? '&' : '?'}source=${defaultQuery?.source}`
  //     );
  //   }
  //   // Disable to switch login / register
  //   if (disableSwitch) {
  //     queryParams = queryParams.concat(
  //       `${queryParams.includes('?') ? '&' : '?'}disableSwitch=1`
  //     );
  //   }
  //   // Execute the following steps of user guidance flow after register successfully
  //   if (preAction) {
  //     queryParams = queryParams.concat(
  //       `${queryParams.includes('?') ? '&' : '?'}preAction=1`
  //     );
  //   }
  //   iframe.src = `${configLang(window, locale).url}${queryParams}`;
  // };
  // function init(window, iframe) {
  //   initIframe(window, iframe);
  // }

  // function receiveMessageListener() {
  //   window.addEventListener('message', receiveMessage, false);
  // }
  // function receiveMessage(event: any = {}) {
  //   const { data } = event;
  //   if (data === 'exchangeLogin') {
  //     setShowRegState(false);
  //   }
  //   if (data === 'exchangeRegister') {
  //     setShowRegState(true);
  //   }
  //   if (data === 'loginClose') {
  //     closeModel();
  //     setTimeout(() => {
  //       setLoginClose(true);
  //     }, 50);
  //   }
  //   if (data === 'registerClose') {
  //     closeModel();
  //     setTimeout(() => {
  //       setRegisterClose(true);
  //     }, 50);
  //   }
  //   if (data === 'loginSuccess') {
  //     closeModel();
  //     setLoginSuccess(true);
  //   }
  //   if (data === 'registerSuccess') {
  //     closeModel();
  //     setRegisterSuccess(true);
  //   }
  // }

  const [loginSuccess, setLoginSuccess] = useState(false);
  const [registerSuccess, setRegisterSuccess] = useState(false);
  const [loginClose, setLoginClose] = useState(false);
  const [registerClose, setRegisterClose] = useState(false);

  return (
    <QuickLoginContext.Provider
      value={{
        loginSuccess,
        registerSuccess,
        loginClose,
        registerClose,
        openModel: openModel,
        closeModel: closeModel,
      }}
    >
      {children}
    </QuickLoginContext.Provider>
  );
};

const useQuickLogin = () => {
  const context = useContext(QuickLoginContext);
  return context;
};
export { QuickLoginContext, useQuickLogin };
